const CookieName = "webrtcReactValues";
export default CookieName;